import React from 'react';
import './costs.scss';

import {Logout,IsRole_Admin,IsRole_OfficeManager, tipoPagamentoOptions} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import costDetail from './costDetail.js';

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

//import FileUploader from 'devextreme-react/file-uploader';
import {Popup} from 'devextreme-react/popup';
//import { Button as PopupButton} from 'devextreme-react/button';

import { createStore } from 'devextreme-aspnet-data';

//import {Form as PopupForm} from 'devextreme-react/form';

import { SimpleItem, GroupItem, Item, TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';

import { useState, useEffect, useCallback,useRef} from "react";
import notify from 'devextreme/ui/notify';

import {Button as ToolbarButton} from 'devextreme-react/button';

import { confirm } from 'devextreme/ui/dialog';
//import { CheckBox } from 'devextreme-react/check-box';
import { formatNumber } from 'devextreme/localization';

//import Query from 'devextreme/data/query';

//const updateActionUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitore/FileUpload';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitore'
//const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitoreRiepilogo'
const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Costi'
//const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitoreSoggetto'
//const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse'

//const editorOptions = { readonly: true, format: '###,##0.00'};
//const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};
const notesEditorOptionsLarge = { height: 68, maxLength: 1000};

const debug = process.env.ENTITY_DEBUG;

export const numeriRata =  [{id:1,desc: '1'},{id:2,desc: '2'},{id:3,desc: '3'},{id:4,desc: '4'},{id:5,desc: '5'},{id:6,desc: '6'}];

export default function Costs(props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;

  const initYear = isInProject? 0:new Date().getFullYear();
  var costsDataGridRef = React.createRef();

  const [stati, setStati] = useState({});
  //const [fornitori, setFornitori] = useState({});
  const [fornitori, setFornitori] = useState([]);
  const [collaboratori, setCollaboratori] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [emittenti, setEmittenti] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});
  const [valute, setValute] = useState({});
  const [modalitaPagam, setModalitaPagam] = useState({});
  const [tipiDocumento, setTipoDocumento] = useState({});
  const [currentId, setCurrentId] = useState(0);
  const [currentDocNo, setCurrentDocNo] = useState();
  //const [currentXMLDocNo, setCurrentXMLDocNo] = useState();
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isGoToProject, setIsGoToProject] = useState(false);
  //const [isToNumber, setIsToNumber] = useState(false);
  //const [isToSendSDI, setIsToSendSDI] = useState(false);
  const [isToUpdProceeds, setIsToUpdProceeds] = useState(false);
  const [hasProject, setHasProject] = useState(false);

  const [currentPrj, setCurrentPrj] = useState(0);
  const [currentPrjNo, setCurrentPrjNo] = useState();
  const [isPrjSelected, setIsPrjSelected] = useState(false);

  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(initYear);
  const [fornitoreFilter, setFornitoreFilter] = useState();
  const [intermediarioFilter, setIntermediarioFilter] = useState(210);
  const [statoFilter, setStatoFilter] = useState();
  const [isStorico, setIsStorico] = useState(false);

  const [isEditable, setIsEditable] = useState(true);
  const [isCreditNote, setIsCreditNote] = useState(true);
  //const formElement = useRef(null);


  const [isPopupVisible2, setPopupVisibility2] = useState(false);
  const togglePopup2 = () => {
    setPopupVisibility2(!isPopupVisible2);
  };

  const { user } = useAuth(); 

  if (!user) 
    Logout();

  const isAdmin =IsRole_Admin();
  const isOfficeManager =IsRole_OfficeManager();

  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    fornitore: fornitoreFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    commessa: projectId,
  };

  //const notesEditorOptions = { height: 38 };

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl3 + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertActionCost',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  // const remoteDataSource2 = createStore({

  //   key: 'id',
  //   loadUrl: serviceUrl2 + '/FindByFatturaFornitore/' + currentId,
  //   onBeforeSend: (method, ajaxOptions) => {
  //     ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
  //   }  
  
  // });

  // const remoteDataSource4 = createStore({

  //   //  byKey: (key) => {
  //   //    return fetch(serviceUrl4 + '/FindByOrdineCliente/' + '7');
  //   //  },
  //   key: 'id',
  //   loadUrl: serviceUrl4 + '/FindByFatturaFornitore/' + currentId,
  //   updateUrl:serviceUrl4 + '/UpdateAction',
  //   onBeforeSend: (method, ajaxOptions) => {
  //     ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
  //   }  
    
  // });


  function onEditingStart(e) {
    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA

    //setCurrentId(e.key);

  }

  const onEditorPreparing = (e) => {
    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    // if(e.dataField === "destinazioneId" && e.parentType ==="dataRow"){
    //   e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    // }
    if(e.dataField === "intermediarioId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }

    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      if (!(e.row.data.statoId === 1) || e.row.data.statoId === null)
        setIsEditable(false)
      else
        setIsEditable(true)
    }

  }  

  function onRowInserting(e) {
    e.data.createBy = user.name;
  };

 
  const remoteDataSource6 = createStore({

    key: 'id',
    loadUrl: serviceUrl6 + '/GetOpen',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
  });

  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaStato';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl2 =  newServiceUrl2 + "/GetFornitori";

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

      const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
      var newUrl5 =  newServiceUrl5 + "/GetAction";

      const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
      var newUrl6 =  newServiceUrl6 + "/GetAction";

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
      var newUrl8 =  newServiceUrl8 + "/GetAction";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniCosti';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      //   const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/RataStato';
      // var newUrl12 =  newServiceUrl12 + "/GetAction";

      // const newServiceUrl10 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      // var newUrl10 =  newServiceUrl10 + "/GetEmittentiFornitoriWithDefault";

      // const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_TipoDocumentiFiscali';
      // var newUrl13 =  newServiceUrl13 + "/GetAction";

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const response2 = await fetch(newUrl2,requestOptions);
        const json2 = await response2.json();
        if (debug === 1)
          console.log(json2);
        setFornitori(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        if (debug === 1)
          console.log(json4);
        setValute(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        if (debug === 1)
          console.log(json5);
        setModalitaPagam(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        if (debug === 1)
          console.log(json6);
        setCondizioniPagam(json6);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
         console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        // const response10 = await fetch(newUrl10,requestOptions);
        // const json10 = await response10.json();
        // if (debug === 1)
        //   console.log(json10);
        // setEmittenti(json10);

        // const response12 = await fetch(newUrl12);
        // const json12 = await response12.json();
        // if (debug === 1)
        //   console.log(json12);
        // setStatiRate(json12);

        // const response13 = await fetch(newUrl13);
        // const json13 = await response13.json();
        // if (debug === 1)
        //   console.log(json13);
        // setTipoDocumento(json13);


      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  function refreshDataGrid() {
    costsDataGridRef.instance().refresh();
  }

  const fornitoriExtended = (fornitori || []).map(f => ({
    ...f,
    displayName: f.ragioneSociale || `${f.nome ?? ""} ${f.cognome ?? ""}`.trim()
  }));

  const allowedPageSizes = [5, 10, 20];

  const aggiungiACommessa= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/AddSupplierInvoiceToProject/' + currentPrj + '/' +currentRow;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function addToProject(e) {
    let result = confirm("<i>Aggiungere il documento selezionato alla Commessa " + currentPrjNo + "?</i>", "Aggiungi a Commessa");
        result.then((dialogResult) => {
          if  (dialogResult) {
            aggiungiACommessa();
            setPopupVisibility2(false);
          }  
        });
  }


  function updateMovs() {    
    let result = confirm("<i>Aggiornare i Pagamenti della fattura selezionata'?</i>", "Aggiorna Pagamenti");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow);
      }  
    });
  };

  const aggiornaMovimenti= (idFattura) => {
      
    var path = "";
    path = '/api/FatturaFornitore/UpdatePaymentMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function duplicate(e) {
    let result = confirm("<i>Procedere con la duplicazione della spesa?</i>", "Duplicazione Spesa");
    result.then((dialogResult) => {
      if  (dialogResult) {
        duplica(currentRow);
      }  
    });
  }

  const duplica= (idFattura) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitore/Duplicate/' + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        costsDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {

      //var intermediarioInfo= getIntermediarioById(data.intermediarioId);

      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      //setCurrentXMLDocNo("IT" + intermediarioInfo.cf + "_" + data.numero);
      //console.log("SELECTED: " + "IT" + intermediarioInfo.cf + "_" + data.numero);
      setIsRowSelected(true);
     
      if (data.refId === null && (data.statoId === 2 || data.statoId === 3))
        setIsToUpdProceeds(true)
      else
        setIsToUpdProceeds(false)

      if (data.codiceCommessa !== null)
        setHasProject(true)
      else
        setHasProject(false)
      console.log("SELECTED: " + data.id);
      //setCurrentId(e.currentSelectedRowKeys);

    } else{
      setIsRowSelected(false);
      setIsToUpdProceeds(false)
      setHasProject(false)
    }

    if (data != null && data.statoId > 1)
      setIsGoToProject(true);
    else
      setIsGoToProject(false);
    
  }

  function customizeText(data) {
    return `Spese: ${data.value}`;
  }

  function customizeData(data) {
    return `${formatNumber(data.value, '###,##0.00')}`;
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuova Spesa'
  };

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };
  
  const selectBoxOptions2 = {
    width: 210,
    items: fornitoriExtended,
    valueExpr: 'id',
    displayExpr: 'displayName',
    placeholder:"<Fornitori>",
    showClearButton:true,
    searchEnabled:true,
    onValueChanged: (args) => {
      setFornitoreFilter(args.value);
    },
    value: fornitoreFilter,
  };
  

  const selectBoxOptions3 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  const selectBoxOptions4 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };

  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        { if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #558ea7";
          else if (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
          else if (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
          else if (e.data.statoId === 4)
            e.cellElement.style.cssText = "color: white; background-color: red";
          else if (e.data.statoId === 5)
            e.cellElement.style.cssText = "color: white; background-color: #E0CF1C";
          else if (e.data.statoId === 6)
            e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
        }
    }
  }


  
  function setNCValue(rowData, value) {
    if (value === 4)
      setIsCreditNote(true);
    else
      setIsCreditNote(false);
    this.defaultSetCellValue(rowData, value); 
  };

  const showDeleteButton = useCallback((e) => {
    return (e.row.data.statoId !== 3 & e.row.data.statoId !== 2) || isAdmin || isOfficeManager;
  }, []);

    const showUpdateButton = useCallback((e) => {
    return e.row.data.statoId !== 3 || isAdmin || isOfficeManager;
  }, []);


  function calculateTotale(rowData) {
    return rowData.tipoDocumentoFiscaleId === 4  ? rowData.importoTotale*-1: rowData.importoTotale;
  };
  function calculateImponibile(rowData) {
    return rowData.tipoDocumentoFiscaleId === 4  ? rowData.imponibile*-1: rowData.imponibile;
  };


  function cancelAddToProject()  {
    setPopupVisibility2(false);
    setCurrentPrj(0);
    setCurrentPrjNo(0);
    setIsPrjSelected(false);
  };

  function onRowSelectionChangedPrj({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentPrj(data.id);
      setCurrentPrjNo(data.codice);
      setIsPrjSelected(true);
    } else{
      setCurrentPrj(0);
      setIsPrjSelected(false);
    }
  }


  const renderContent2 = () =>  {
    return (
      <div>

  { isPrjSelected &&
    <p>Aggiungi il documento selezionato alla Commessa <b>{currentPrjNo}</b></p>
  }
     
      <DataGrid id="grid-popup2"
        className={'dx-card wide-card'}
        dataSource={remoteDataSource6}
        showBorders={true}
        columnHidingEnabled={true}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        onSelectionChanged={onRowSelectionChangedPrj}
      >
        <Pager
            showPageSizeSelector={false}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
        />
        <Selection mode="single" />
        <Paging defaultPageSize={10} />
       
        <Toolbar>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='todo'
              hint='Conferma'
              disabled={!isPrjSelected}
              onClick={addToProject} 
            />
          </Item>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Annulla'
              onClick={cancelAddToProject} 
            />
          </Item>    
      
        </Toolbar>
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" caption="Codice" width={110}/>
        <Column dataField="nome"  caption="Nome" />
        <Column dataField="fornitoreId" caption="Fornitore" >
          <Lookup dataSource={fornitori} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
      </DataGrid>
      </div>            
    )
  }



  return (
  <React.Fragment>
    { !isInProject &&  <h2 className={'content-block'}>Registrazione Spese</h2> }
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid id="grid-container"
          ref={ref => costsDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}
          onSelectionChanged={onRowSelectionChanged}
          //onRowExpanded={onRowExpanded}
          onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          onCellPrepared={onCellPrepared}
          //onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          //onRowValidating={onRowValidating}
          dateSerializationFormat= {'yyyy-MM-dd'}
        >
         { !isInProject
            &&   
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
           
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='copy'
                hint='Duplica'
                onClick={duplicate}
                disabled={!isRowSelected} />
            </Item>       
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='columnchooser'
                hint='Aggiungi a Commessa'
                onClick={togglePopup2}
                disabled={hasProject} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='showpanel'
                hint='Aggiorna Pagamenti'
                onClick={updateMovs} 
                disabled={!hasProject}
                />
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
          }

          <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
              column="numero"
              summaryType="count"
              customizeText={customizeText}
            />
            <TotalItem
              column="imponibileV"
              summaryType="sum"
              customizeText={customizeData}
            />
          </Summary>
          <Selection mode="single" />
          <SearchPanel visible={true}
            width={180}
            placeholder="Cerca..."
          />
          <Editing
            mode="popup"
            allowUpdating={true}
            allowAdding={!isInProject}
            allowDeleting={true}
            useIcons={true}
          >
          
          <Popup title="Registrazione Spesa" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
                <Item dataField="numeroDoc" colSpan={2} isRequired= "true"/>
                <Item dataField="statoId"colSpan={2} />
                <Item dataField="dataDoc"colSpan={2} />
                <Item dataField="dataScadenza"colSpan={2}/>
                <Item dataField="oggetto"colSpan={4}/>
                
                <Item dataField="fornitoreId" colSpan={2} isRequired= "true"/>
             
                <Item dataField="riferimentoInternoId" colSpan={2} />
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
 
              </Item> 

              <Item itemType="group" caption="Dati Pagamento" colCount={4} colSpan={2}>
                <Item dataField="valutaId" colSpan={2} />
                <Item dataField="tipoPagamento" colSpan={2} />
                <Item dataField="modalitaPagamentoId" colSpan={2} isRequired= "true"/>
                <Item dataField="condizioniPagamentoId" colSpan={2} />
                <Item dataField="bancaDescrizione" colSpan={2} />
                <Item dataField="iban" colSpan={2} />
                <Item dataField="dataPagamento" colSpan={2} />
                <Item type="empty" colSpan={2} />
                <Item
                  dataField="descrizione"
                  editorType="dxTextArea"
                  caption="Note"
                  colSpan={4}
                  editorOptions={notesEditorOptionsLarge} />
                </Item>
      
            </Form>
          </Editing>
              

          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num" width={110}/>
          <Column dataField="numeroDoc" visible={false}/>
          <Column dataField="categoriaDocumento" caption="Tipo" visible={false} width={110}/>
          <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data doc." />
          <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Data Scadenza"  />
          <Column dataField="numeroFatturaRif" caption="Numero Rif. Fattura" visible={false}/>
          <Column dataField="dataFatturaRif" caption="Data Rif. Fattura" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
          <Column dataField="fornitoreId" caption="Fornitore" >
            <Lookup dataSource={fornitoriExtended} valueExpr="id" displayExpr="displayName" />
          </Column>
          <Column dataField="oggetto" caption="Oggetto" />
          <Column dataField="tipoDocumentoFiscaleId" caption="Tipo Documento"  visible={false} setCellValue={setNCValue}>
            <Lookup dataSource={tipiDocumento} valueExpr="id" displayExpr="descrizioneEstesa" />
          </Column>
          <Column dataField="destinazioneId" caption="Destinatario"  visible={false}>
            <Lookup dataSource={fornitoriExtended} valueExpr="id" displayExpr="displayName" />  
          </Column>
          <Column dataField="riferimentoInternoId" caption="Collaboratore" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" width={240} visible={false}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="emittenteId" caption="Emittente/Terzo" width={240}  visible={false} showClearButton={true}>
            <Lookup dataSource={emittenti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="importoTotale"  width={100} caption="Totale" visible={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column name ="imponibileV" caption="Imponibile" calculateCellValue={calculateImponibile} allowEditing={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column name ="totaleV" caption="Totale" calculateCellValue={calculateTotale} allowEditing={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoLordo" visible={false} >
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="percSconto" visible={false} />
          <Column dataField="importoSconto" visible={false} />
          <Column dataField="imponibile" visible={false} />
          <Column dataField="importoScontato" visible={false} />
          <Column dataField="imposte" visible={false} />
          <Column dataField="statoId" caption="Stato" width={110}>
            <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="valutaId" caption="Valuta" width={80}>
            <Lookup dataSource={valute} valueExpr="id" displayExpr="codice" />
          </Column>
          <Column dataField="codiceCommessa"  caption="Commessa" visible={true} width={90}></Column>
          <Column dataField="descrizione" caption="Note" 
            hidingPriority={0}    // la prima ad andare nei puntini
            visible={true}        // resta disponibile
            width={0}             // forza il passaggio nei puntini
          />
          <Column dataField="datiPagamentoInFE"  visible={false}></Column>
          <Column dataField="dataPagamento" caption="Data Pagamento" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
          <Column dataField="tipoPagamento"  visible={false} >
            <Lookup dataSource={tipoPagamentoOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="bollo" caption="Bollo Virtuale" visible={false} ></Column>
          <Column dataField="modalitaPagamentoId"  caption="Modalità Pagamento" visible={false}>
            <Lookup dataSource={modalitaPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamentoId" caption="Condiz. Pagamento" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="bancaDescrizione" visible={false} caption="Banca" />
          <Column dataField="iban" visible={false} caption="IBAN"/>

          <Column dataField="updateBy" visible={false}/>
          <Column dataField="createBy" visible={false}/>
          <Column dataField="refId" visible={false}/>
          <Column dataField="codiceBenestare" visible={false}/>
          <Column type="buttons">
            <Button name="edit"  visible={showUpdateButton}/>
            <Button name="delete" visible={showDeleteButton}/>
          </Column>

          <MasterDetail
            enabled={true}
            component={costDetail}
          />
         
        </DataGrid>

        <div>
          <Popup
            width={800}
            height={640} 
            showTitle={true}
            title="Seleziona Commessa"
            visible={isPopupVisible2}
            hideOnOutsideClick={true}
            onHiding={togglePopup2}
            contentRender={renderContent2}
          > 
          </Popup> 
        </div>



      </div>
    </div>
  </React.Fragment>
  )
};

